import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';

const getScopePage = () => ShowPageScopeCollector.get(['layout_options', 'base_url', 'getIsLightweight']);

export function drawBackgroundMockup({ fields, canvas }) {
  const { layout_options, base_url, getIsLightweight } = getScopePage();
  const is_lightweight = getIsLightweight();
  
  if (layout_options && layout_options.show_mockup) {
    fields.forEach((field) => {
      const options = JSON.parse(field.options);
      
      if (field.type === 'Background Mockup') {
        const url = base_url + '/share?file=' + options['Filename'];
        
        fabric.Image.fromURL(url + is_lightweight, function (img) {
          // add background image
          canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
            scaleX: canvas.width / img.width,
            scaleY: canvas.height / img.height,
          });
        });
      }
    });
  }
}